<!--  -->
<template>
  <div>
    <section class="course-area course-area4">
    <div class="course-wrapper">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="course-tab-wrap d-flex align-items-center">
                        <ul class="course-tab-list nav nav-tabs align-items-center" role="tablist"
                            id="review">
                            <li role="presentation">
                                <a href="#tab1" role="tab" data-toggle="tab" class="active" aria-selected="true">
                                    <span class="la la-th-large" data-toggle="tooltip" data-placement="top" title="Grid view"></span>
                                </a>
                            </li>
                            <li role="presentation">
                                <a href="#tab2" role="tab" data-toggle="tab" aria-selected="false">
                                    <span class="la la-th-list" data-toggle="tooltip" data-placement="top" title="List view"></span>
                                </a>
                            </li>
                            <li><span class="courses-showing-text"> 共有{{intTotal}}课程</span></li>
                        </ul>
                        <div class="course-filter d-flex align-items-center ml-auto">
                            <div class="courses-ordering">
                                <select class="target-course" v-model="searchType" aria-placeholder="课程科目">
                                    <option value=""  selected>所有科目</option>
                                    <option v-for="(courcate,index) in courcates" :key="index" :value="courcate.name">{{courcate.name}}</option>
                                </select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end course-filter -->
                    </div><!-- end course-tab-wrap -->
                </div><!-- end col-lg-12 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-wrapper -->
    <div class="course-content-wrapper">
        <div class="container">
            <div class="row course-item-wrap">
                <div class="col-lg-8">
                    <div class="tab-content">
                        <div role="tabpanel" class="tab-pane fade show active" id="tab1">
                            <div class="row course-block">
                                <div class="col-lg-6" v-for="(course,index) in courses" :key="index">
                                    <div class="course-item">
                                        <div class="course-img">
                                            <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                            <div class="course-tooltip" v-if="course.spltip">
                                                <span class="tooltip-label">{{course.spltip}}</span>
                                            </div>
                                            
                                        </div><!-- end course-img -->
                                        <div class="course-content">
                                            <p class="course__label">
                                                <span class="course__label-text">{{course.level}}</span>
                                                <!-- <router-link  class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="加入愿望单"><span class="la la-heart-o"></span></router-link> -->
                                            </p>
                                            
                                            <h3 class="course__title">
                                                <router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link>
                                            </h3>
                                            <p class="course__author">
                                                <a>{{course.author}}</a>
                                            </p>
                                            <div class="rating-wrap d-flex">
                                                    <ul class="review-stars d-flex" v-if="course.stars">
                                                        <li><span :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></span></li>
                                                    </ul>
                                                     <ul class="review-stars d-flex" v-else>
                                                        <li><span>暂无评分</span></li>
                                                    </ul>
                                                    <span class="star-rating-wrap" v-if="course.stars">
                                                        <span class="star__rating">{{parseFloat(course.stars).toFixed(1)}}</span>
                                                    </span>
                                                </div><!-- end rating-wrap -->
                                            <div class="course-meta">
                                                    <ul class="course__list d-flex">
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-play-circle"></i> {{course.totalClass}}课时
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-clock-o"></i> {{course.totalTime}}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div><!-- end course-meta -->
                                            <div class="course-price-wrap">
                                                    <span class="course__price"><span class="course__before-price" v-if="course.befprice">￥{{course.befprice}}</span>{{`${course.price=='0'?'免费':'￥'+course.price}`}} </span>
                                                    <!-- <div class="course-buytip" v-if="!course.isBuy">
                                                        <span class="tooltip-label">已购买</span>
                                                    </div> -->
                                            </div><!-- end course-price-wrap -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-6 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                        <div role="tabpanel" class="tab-pane fade" id="tab2">
                            <div class="row course-block course-list-block">
                                <div class="col-lg-12" v-for="(course,index) in courses" :key="index">
                                    <div class="course-item">
                                        <div class="course-img">
                                           <router-link :to="`/courview/info/${course._id}`" class="course__img"><img :src="`${global.remoteIp}/uploads/${course.picsrc}`" alt=""></router-link>
                                        </div><!-- end course-img -->
                                        <div class="course-content">
                                            <p class="course__label">
                                                <span class="course__label-text">{{course.spltip}}</span>
                                                <a class="course__collection-icon" data-toggle="tooltip" data-placement="top" title="加入愿望单"><span class="la la-heart-o"></span></a>
                                            </p>
                                            <h3 class="course__title">
                                              <router-link :to="`/courview/info/${course._id}`">{{course.title}}</router-link>
                                            </h3>
                                            <p class="course__author">
                                                 <a>{{course.author}}</a>
                                            </p>
                                            <div class="rating-wrap d-flex">
                                                    <ul class="review-stars d-flex" v-if="course.stars">
                                                        <li><span :class="`la la-star${course.stars==0.5?'-half':course.stars>=1?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==1.5?'-half':course.stars>=2?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==2.5?'-half':course.stars>=3?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==3.5?'-half':course.stars>=4?'':'-o'}`"></span></li>
                                                        <li><span :class="`la la-star${course.stars==4.5?'-half':course.stars>=5?'':'-o'}`"></span></li>
                                                    </ul>
                                                     <ul class="review-stars d-flex" v-else>
                                                        <li><span>暂无评分</span></li>
                                                    </ul>
                                                    <span class="star-rating-wrap" v-if="course.stars">
                                                        <span class="star__rating">{{parseFloat(course.stars).toFixed(1)}}</span>
                                                    </span>
                                                </div><!-- end rating-wrap -->
                                            <div class="course-meta">
                                                    <ul class="course__list d-flex">
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-play-circle"></i> {{course.totalClass}}
                                                            </span>
                                                        </li>
                                                        <li>
                                                            <span class="meta__date">
                                                                <i class="la la-clock-o"></i> {{course.totalTime}}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div><!-- end course-meta -->
                                                <div class="course-price-wrap">
                                                    <span class="course__price"><span class="course__before-price" v-if="course.befprice">￥{{course.befprice}}</span>{{`${course.price=='0'?'免费':'￥'+course.price}`}} </span>
                                                    <!-- <a href="#" class="course__btn">加入购物车</a> -->
                                                </div><!-- end course-price-wrap -->
                                        </div><!-- end course-content -->
                                    </div><!-- end course-item -->
                                </div><!-- end col-lg-12 -->
                            </div><!-- end course-block -->
                        </div><!-- end tab-pane -->
                    </div><!-- end tab-content -->
                    <div class="pagination-wrap">
                        <nav aria-label="Page navigation">
                            <el-pagination
                            background
                            :page-size="6"
                            :hide-on-single-page="intTotal<=6"
                            layout="prev, pager, next"
                            @current-change="toPage"
                            @prev-click="toPage"
                            @next-click="toPage"
                            :total="intTotal">
                        </el-pagination>
                        </nav>
                    </div><!-- end pagination-wrap -->
                </div><!-- end col-lg-8 -->
                <div class="col-lg-4">
                    <div class="sidebar">
                        <div class="sidebar-widget">
                            <h3 class="widget__title">搜索</h3>
                            <span class="section__divider"></span>
                            <div class="contact-form-action">
                                <form>
                                    <div class="form-group">
                                        <input class="form-control" type="search" v-model="searchWords" placeholder="搜索课程...">
                                        <button type="button" class="search__btn" @click="toPage(1)"><span class="la la-search"></span></button>
                                    </div>
                                </form>
                            </div><!-- end contact-form-action -->
                        </div><!-- end sidebar-widget -->
                        <div class="sidebar-widget level-widget">
                            <h3 class="widget__title">级别分类</h3>
                            <span class="section__divider"></span>
                            <ul class="instructor__list">
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb1" value="高级" v-model="searchLevel"/>
                                        <label for="chb1">高级</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb2" value="中级" v-model="searchLevel"/>
                                        <label for="chb2">中级</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb3" value="初级" v-model="searchLevel"/>
                                        <label for="chb3">初级</label>
                                    </div>
                                </li>
                            </ul>
                        </div><!-- end sidebar-widget -->
                        <div class="sidebar-widget sort-widget">
                            <h3 class="widget__title">排序</h3>
                            <span class="section__divider"></span>
                            <div class="courses-ordering">
                                <select class="target-course" v-model="sortType">
                                    <option value="-createdAt">发布时间</option>
                                    <option value="stars">评分</option>
                                    <option value="price">价格</option>
                                    <option value="students">购买人数</option>
                                </select>
                            </div><!-- end courses-ordering -->
                        </div><!-- end sidebar-widget -->
                        <div class="sidebar-widget price-widget">
                            <h3 class="widget__title">价格</h3>
                            <span class="section__divider"></span>
                            <ul class="instructor__list">
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb4" value="0" v-model="searchPrice"/>
                                        <label for="chb4" >免费</label>
                                    </div>
                                </li>
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb5" value="1" v-model="searchPrice"/>
                                        <label for="chb5">收费</label>
                                    </div>
                                </li>
                            </ul>
                        </div><!-- end sidebar-widget -->
                        <div class="sidebar-widget rating-widget">
                            <h3 class="widget__title">评分</h3>
                            <span class="section__divider"></span>
                            <ul class="rating__list">
                                <li>
                                    <span class="la la-star"></span><span class="la la-star"></span><span class="la la-star"></span><span class="la la-star"></span><span class="la la-star"></span>
                                    <label class="review-label">
                                        <input type="radio" checked="checked" value="5" v-model="searchStars">
                                        <span class="review-mark"></span>
                                    </label>
                                </li>
                                <li>
                                    <span class="la la-star"></span> <span class="la la-star"></span><span class="la la-star"></span><span class="la la-star"></span>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="4" v-model="searchStars">
                                        <span class="review-mark"></span>
                                    </label>
                                </li>
                                <li>
                                    <span class="la la-star"></span><span class="la la-star"></span><span class="la la-star"></span>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="3" v-model="searchStars">
                                        <span class="review-mark"></span>
                                    </label>
                                </li>
                                <li>
                                    <span class="la la-star"></span><span class="la la-star"></span>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="2" v-model="searchStars">
                                        <span class="review-mark"></span>
                                    </label>
                                </li>
                                <li>
                                    <span class="la la-star"></span>
                                    <label class="review-label">
                                        <input type="radio" name="review-radio" value="1" v-model="searchStars">
                                        <span class="review-mark"></span>
                                    </label>
                                </li>
                            </ul>
                        </div><!-- end sidebar-widget -->
                        <div class="sidebar-widget instructor-widget">
                            <h3 class="widget__title">讲师</h3>
                            <span class="section__divider"></span>
                            <ul class="instructor__list">
                                <li>
                                    <div class="custom-checkbox">
                                        <input type="checkbox" id="chb6" value="all" v-model="searchAuthor"/>
                                        <label for="chb6">所有讲师</label>
                                    </div>
                                </li>
                                <li v-for="(author,index) in authors" :key="index">
                                    <div class="custom-checkbox">
                                        <input type="checkbox" :id="`chb7${index}`" :value="author.title" v-model="searchAuthor"/>
                                        <label :for="`chb7${index}`">{{author.title}}</label>
                                    </div>
                                </li>
                            </ul>
                            <div class="button-shared">
                                <router-link :to="`/views/${plateid}`" class="theme-btn">查看所有讲师信息</router-link>
                            </div>
                        </div><!-- end sidebar-widget -->
                    </div><!-- end sidebar -->
                </div><!-- end col-lg-4 -->
            </div><!-- end row -->
        </div><!-- end container -->
    </div><!-- end course-content-wrapper -->
</section><!-- end courses-area -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data() {
    return {
      courcates: [],
      courses: [],
      global,
      searchType: "",
      searchWords: "",
      intTotal: 20,
      intCurrent: 1,
      searchAuthor: [],
      plateid: "",
      authors: [],
      searchStars: "",
      searchPrice: [],
      sortType: "",
      searchLevel: [],
    };
  },
  props: {
    plates: Array,
  },
  components: {},

  computed: {},

  mounted() {
    this.$axios.get("/api/courseTypes?sort=-createdAt").then((res) => {
      if (res.data) {
        this.courcates = res.data.data;
      }
    });
    
    for (var i = 0; i < this.plates.length; i++) {
      if (this.plates[i].name == "名师简介") { 
        this.plateid = this.plates[i]._id;
      }
    }
    this.$axios
      .get(`/api/articles?plateid=${this.plateid}&limit=6&sort=-createdAt`)
      .then((res) => {
        if (res.data) {
          this.authors = res.data.data;
        }
      });
    this.$axios
      .get("/api/courses/visitor?page=1&limit=6&sort=-createdAt&type[in]="+ this.$root.hasCourse)
      .then((res) => {
        if (res.data) {
          this.courses = res.data.data;
          this.intTotal = res.data.total;
        }
      });
  },
  watch: {
    searchAuthor() {
      this.toPage(1);
    },
    searchType() {
      this.toPage(1);
    },
    searchWords() {
      this.toPage(1);
    },
    searchStars() {
      this.toPage(1);
    },
    searchPrice() {
      this.toPage(1);
    },
    sortType() {
      this.toPage(1);
    },
    searchLevel() {
      this.toPage(1);
    },
  },
  methods: {
    toTop() {
    //   document.body.scrollTop = 0;
    //   document.documentElement.scrollTop = 0;
    },
    toPage(intcount) {
        if(this.$root.hasCourse.length==0) {
            return
        }
      if (intcount) this.intCurrent = intcount;
      var searchConditions = "";
      if (this.searchType) {
        searchConditions += "&type=" + this.searchType;
      }
      if (this.searchWords) {
        searchConditions += "&title=$regex:" + this.searchWords;
      }
      if (this.searchAuthor && this.searchAuthor.length > 0) {
        searchConditions += "&author[in]=" + this.searchAuthor;
      }
      if (this.searchLevel && this.searchLevel.length > 0) {
        searchConditions += "&level[in]=" + this.searchLevel;
      }
      if (this.searchStars) {
        searchConditions += "&stars=" + this.searchStars;
      }
      if (this.sortType) {
        searchConditions += "&sort=" + this.sortType;
      } else {
        searchConditions += "&sort=-createdAt";
      }
      if (this.searchPrice == "0") {
        searchConditions += "&price=0";
      } else {
        searchConditions += "&price[ne]=0";
      }
      this.$axios
        .get(
          `/api/courses/visitor?page=${
            this.intCurrent
          }&limit=6${searchConditions}&_id[in]=${this.$root.hasCourse.join(",")}`
        )
        .then((res) => {
          if (res.data) {
            this.intTotal = res.data.total;
            this.courses = res.data.data;
            this.toTop();
          }
        });
    },
  },
};
</script>
<style scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #51be78;
}
/deep/ .el-pager li.active {
  color: #51be78;
}
</style>
